import { Routes } from '@angular/router';
import { CountryResolverServiceService } from '@fitness-force/api';

// We'll keep the existing routes from app-routing.module.ts
// but convert them to the standalone format
export const routes: Routes = [
  {
    path: '',
    redirectTo: 'crm',
    pathMatch: 'full',
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./features/auth/auth.routes').then((m) => m.AUTH_ROUTES),
    data: { isTenant: false },
  },
  {
    path: 'backendauth',
    loadComponent: () =>
      import('./features/auth/callback/auth-callback.component').then(
        (a) => a.AuthCallbackComponent,
      ),
    data: { isTenant: false },
  },
  {
    path: 'crm',
    resolve: { CountryResolverServiceService },
    loadChildren: () =>
      import('./features/crm/crm.routes').then((m) => m.CRM_ROUTES),
    data: { isTenant: true, breadcrumb: 'CRM', preload: 'high' },
  },
  {
    path: 'admin',
    resolve: { CountryResolverServiceService },
    loadChildren: () =>
      import('./features/admin/admin.routes').then((m) => m.ADMIN_ROUTES),
    data: { isTenant: true, breadcrumb: 'ADMIN', preload: 'medium' },
  },
  {
    path: 'company-settings',
    resolve: { CountryResolverServiceService },
    loadChildren: () =>
      import('./features/company-settings/company-settings.routes').then(
        (m) => m.COMPANY_SETTINGS_ROUTES,
      ),
    data: { isTenant: false, breadcrumb: 'COMPANY_SETTINGS' },
  },
  {
    path: 'enterprise',
    resolve: { CountryResolverServiceService },
    loadChildren: () =>
      import('./features/enterprise/enterprise.routes').then(
        (m) => m.ENTERPRISE_ROUTES,
      ),
    data: { isTenant: true, breadcrumb: 'ENTERPRISE' },
  },
  {
    path: 'report',
    resolve: { CountryResolverServiceService },
    loadChildren: () =>
      import('./features/reports/reports.routes').then((m) => m.REPORTS_ROUTES),
    data: { isTenant: true, breadcrumb: 'REPORT' },
  },
  {
    path: 'audit-trail',
    resolve: { CountryResolverServiceService },
    loadChildren: () =>
      import('@fitness-force/audit-trail').then((m) => m.AUDIT_TRAIL_ROUTES),
    data: { isTenant: true, breadcrumb: 'AUDIT_TRAIL' },
  },
  {
    path: 'schedule',
    resolve: { CountryResolverServiceService },
    loadChildren: () =>
      import('./features/schedule/schedule.routes').then(
        (m) => m.SCHEDULE_ROUTES,
      ),
    data: { isTenant: true, breadcrumb: 'SCHEDULE' },
  },
  {
    path: 'client',
    resolve: { CountryResolverServiceService },
    loadChildren: () =>
      import('./features/client-profile/client-profile.routes').then(
        (m) => m.CLIENT_PROFILE_ROUTES,
      ),
    data: { isTenant: true },
  },
  {
    path: 'client-management',
    resolve: { CountryResolverServiceService },
    loadChildren: () =>
      import('./features/client-management/client-management.routes').then(
        (m) => m.CLIENT_MANAGEMENT_ROUTES,
      ),
    data: { isTenant: true },
  },
  {
    path: 'pos',
    resolve: { CountryResolverServiceService },
    loadChildren: () =>
      import('./features/pos/pos.routes').then((m) => m.POS_ROUTES),
    data: { isTenant: true, breadcrumb: 'pos', preload: 'medium' },
  },
  {
    path: 'signup',
    loadComponent: () =>
      import('./features/company-sign-up/company-sign-up.component').then(
        (c) => c.CompanySignUpComponent,
      ),
  },
  // {
  //   path: 'dashboard',
  //   resolve: { CountryResolverServiceService },
  //   loadChildren: () => import('./features/dashboard/dashboard.module').then(c => c.DashboardModule), data: { isTenant: true, breadcrumb: "CRM" }
  // },
  {
    path: 'dashboard',
    resolve: { CountryResolverServiceService },
    loadChildren: () =>
      import('./features/dashboard/dashboard.routes').then(
        (m) => m.DASHBOARD_ROUTES,
      ),
    data: { isTenant: true, breadcrumb: 'CRM', preload: 'high' },
  },
  {
    path: 'automation',
    resolve: { CountryResolverServiceService },
    loadChildren: () =>
      import('./features/automation/automation.routes').then(
        (m) => m.AUTOMATION_ROUTES,
      ),
    data: { isTenant: true, breadcrumb: 'AUTOMATION' },
  },
  {
    path: 'campaign',
    resolve: { CountryResolverServiceService },
    loadChildren: () =>
      import('./features/campaign/campaign.routes').then(
        (m) => m.CAMPAIGN_ROUTES,
      ),
    data: { isTenant: true, breadcrumb: 'CAMPAIGN' },
  },
  {
    path: 'payout-engine',
    resolve: { CountryResolverServiceService },
    loadChildren: () =>
      import('./features/payout-engine/payout-engine.routes').then(
        (m) => m.PAYOUT_ENGINE_ROUTES,
      ),
    data: { isTenant: true, breadcrumb: 'PAYOUT_ENGINE' },
  },
  {
    path: 'retail-management',
    resolve: { CountryResolverServiceService },
    loadChildren: () =>
      import('./features/retail-billing/retail-billing.routes').then(
        (m) => m.RETAIL_BILLING_ROUTES,
      ),
    data: { isTenant: true, breadcrumb: 'RETAIL_BILLING', claim: 'can_manage_retail' },
  },
  {
    path: 'retail-inventory',
    resolve: { CountryResolverServiceService },
    loadChildren: () =>
      import('./features/retail-inventory/retail-inventory.routes').then(
        (m) => m.RETAIL_INVENTORY_ROUTES,
      ),
    data: { isTenant: true, breadcrumb: 'RETAIL_INVENTORY', claim: 'can_manage_retail' },
  },
  {
    path: 'contract',
    resolve: { CountryResolverServiceService },
    loadChildren: () =>
      import('./features/contract/contract.routes').then(
        (m) => m.CONTRACT_ROUTES,
      ),
    data: { isTenant: true, breadcrumb: 'CONTRACT' },
  },
  // {
  //   path: 'commission-management',
  //   resolve: { CountryResolverServiceService },
  //   loadChildren: () => import('./features/commission-management/commission-management.routes').then(m => m.COMMISSION_MANAGEMENT_ROUTES),
  //   data: { isTenant: true, breadcrumb: "COMMISSION_MANAGEMENT" }
  // },
  {
    path: 'unauthorized',
    loadComponent: () =>
      import('./features/admin/unauthorized/unauthorized.component').then(
        (c) => c.UnauthorizedComponent,
      ),
    data: { isTenant: true },
  },
  {
    path: 'invoice/:uuid',
    loadComponent: () =>
      import('./features/invoice/show-invoice/show-invoice.component').then(
        (c) => c.ShowInvoiceComponent,
      ),
    data: { type: 'Invoice' },
  },
  {
    path: 'sales_return/:uuid',
    loadComponent: () =>
      import('./features/invoice/show-invoice/show-invoice.component').then(
        (c) => c.ShowInvoiceComponent,
      ),
    data: { type: 'SalesReturn' },
  },
  {
    path: 'analytics',
    loadChildren: () =>
      import('./features/analytics/analytics.routes').then(
        (m) => m.ANALYTICS_ROUTES,
      ),
    data: { isTenant: false, breadcrumb: 'ANALYTICS' },
  },
  {
    path: 'company-not-found',
    loadComponent: () =>
      import('@fitness-force/errors').then((a) => a.CompanyNotFoundComponent),
    data: { isTenant: false },
  },
  {
    path: 'tenant-not-found',
    resolve: { CountryResolverServiceService },
    loadComponent: () =>
      import(
        './features/admin/tenant-not-found/tenant-not-found.component'
      ).then((a) => a.TenantNotFoundComponent),
    data: { isTenant: true },
  },
  {
    path: 'company-login',
    loadChildren: () =>
      import('./features/temp-company-login/temp-company-login.routes').then(
        (m) => m.TempCompanyLoginRoutes,
      ),
  },
  {
    path: 'forms/fill/:companyId/:tenantId/:responseId',
    loadComponent: () =>
      import('@fitness-force/survey-form-engine').then(
        (c) => c.FormRunnerComponent,
      ),
    data: { isTenant: false },
  },
  {
    path: '**',
    loadChildren: () =>
      import('./features/page-not-found/page-not-found.routes').then(
        (m) => m.PageNotFoundRoutes,
      ),
  },
];
